"use client";

import { useState, useEffect } from "react";
import { useUser } from "@clerk/nextjs";
import { onOutboundNag } from "@/lib/client/outboundClickNag";
import ProNagModal from "@/components/ProNagModal";

const OUTBOUND_TITLES = [
  "Shopping across multiple stores?",
  "Keep jumping between stores?",
  "Stuck hunting across the web?",
  "KURB tracks it all in one place.",
];

export default function OutboundNagManager() {
  const { isSignedIn } = useUser();
  const [showNag, setShowNag] = useState(false);

  useEffect(() => {
    if (isSignedIn) return;
    return onOutboundNag(() => setShowNag(true));
  }, [isSignedIn]);

  if (isSignedIn) return null;

  return (
    <ProNagModal
      isOpen={showNag}
      onClose={() => setShowNag(false)}
      source="outbound_nag"
      titles={OUTBOUND_TITLES}
      subtitle="Sign up to save your searches and get alerted when new pieces drop."
    />
  );
}
